import { LitElement, html, css } from 'lit'
import {customElement, property, query, state} from 'lit/decorators.js'
import { TConversation } from "./vxc_conversation"

@customElement('vxc-session-view')
export class TSessionView extends TConversation {

    /** properties */
    @property({ type: String }) host: string = ''   
    @property({ type: String }) app : string = ''
    @property({ type: String }) uid : string = ''
    @state() private error: string | null = null


    updated(changedProperties: Map<string | number | symbol, unknown>) {
        console.log('session view :')
        console.dir(changedProperties)
        console.log('uid ?', changedProperties.has('uid'))
        console.log('app ?', changedProperties.has('uid'))
        if (changedProperties.has('uid') && changedProperties.has('app')) {
            console.log('uid :', this.uid, 'app :', this.app)
            this.fetchData();
        }
        else console.log('ignoring...')
        super.update(changedProperties)
    }    

    async fetchData() {
        console.log('fetching', this.app, this.uid)
        if (!this.uid || !this.app) {
            this.dialog = [];
            this.error = null;
            return;
        }

        try {
            const response = await fetch(`${this.host}/apps/${this.app}/chat/${this.uid}`)
            if (!response.ok) throw new Error(`Error: ${response.statusText}`);
            const session = await response.json()
            if(!session?.dialog)    throw new Error('Session not found..')
            this.dialog = session.dialog
            this.error = null
        } 
        catch (err: any) {
            this.error = err.message;
            this.dialog = [];
        }
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-session-view': TSessionView
  }
}
